/* eslint-disable no-underscore-dangle */
import type {
  ISendEmailToAgentError,
  ISendEmailToAgentRequestPayload,
  ISendEmailToAgentResponse,
} from './types'
import type { PostLeadRCMBody } from 'api/instances/rcm'
import type { AxiosError, AxiosResponse } from 'axios'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { publicMessagingApiInstance } from 'api'
import { authService } from 'auth'

import { NAME } from './constant'
import { sendRcm } from './utils'

export const sendEmailToAgent = createAsyncThunk(
  `${NAME}/SEND_EMAIL_TO_AGENT`,
  async (data: ISendEmailToAgentRequestPayload, { rejectWithValue }) => {
    const { recipient, message, property, turnstileToken, turnstile } = data
    const source = 'agent-profile'
    const user = await authService.getUser()
    const postLeadRCMBody: PostLeadRCMBody = {
      email: user?.email,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      owner_id: recipient?._id,
      firstName: user?.given_name,
      mobileNumber: user?.phone_number,
      source,
      automated: true,
    }
    try {
      const response: AxiosResponse<ISendEmailToAgentResponse> =
        await publicMessagingApiInstance.put('/conversations/send-email', {
          recipient,
          message,
          source,
          turnstileToken,
        })

      sendRcm({ postLeadRCMBody, property }).catch(() => true)

      return response
    } catch (e: unknown) {
      const error = e as AxiosError<ISendEmailToAgentError>
      // eslint-disable-next-line no-console
      console.debug('sendEmailToAgent error:', e instanceof Error ? e.message : 'unknown')
      if (!error?.response?.data) {
        return rejectWithValue({
          message: e instanceof Error ? e.message : 'unknown',
        })
      }
      return rejectWithValue(error.response.data)
    } finally {
      if (turnstile) {
        turnstile.reset()
      }
    }
  },
)
export const asyncActions = {
  sendEmailToAgent,
}
